<div class="activity-task-pane" cdkDropListGroup>
	<div class="tasks-container">
		<div class="task-pane-header">
			<h2 class="task-pane-title">{{ titleKey | translate }}</h2>
		</div>
		<div
			cdkDropList
			id="task-list"
			class="task-list-container"
			[class.edit-mode]="isEditMode"
			role="list"
			(cdkDropListDropped)="drop($event)"
			[cdkDropListDisabled]="!isEditMode">
			@for (task of (isEditMode ? (visibleModifiedTasks$ | async) : (visibleFilteredTasks$ | async)); track getTaskReorderId(task); let i = $index) {
				<div class="task-item-wrapper" role="listitem">
					<div
						#listItem
						cdkDrag
						tabindex="0"
						class="task-item"
						[class.active]="selectedTaskType === task.type"
						[class.completed]="task.completed"
						role="link"
						[attr.aria-current]="selectedTaskType === task.type ? 'page' : null"
						[attr.data-cy]="'activity-tasks-' + task.type"
						[attr.data-tour]="shouldShowLearnerTourPulse(task) ? 'task-item-incomplete' : null"
						[attr.aria-label]="isEditMode
							? task.name
							: (task.completed
								? ('activity-task-list_complete-task-aria-label' | translate:{name: task.name})
								: ('activity-task-list_incomplete-task-aria-label' | translate:{name: task.name}))"
						[cdkDragDisabled]="!isEditMode"
						[cdkDragData]="task"
						cdkDragPreviewClass="activity-task-pane__drag-preview"
						(keydown.enter)="onTaskKeydown($event)"
						(keydown.space)="onTaskKeydown($event)"
						(keyup.enter)="onTaskKeyup($event, task)"
						(keyup.space)="onTaskKeyup($event, task)"
						(click)="onTaskClick(task, $event)">

						@if (isEditMode) {
							<div
								class="drag-handle"
								cdkDragHandle
								tabindex="0"
								accessibleDropList
								[accessibleDropListDisabled]="!isEditMode"
								[accessibleDropListUseLiveRegionFallback]="isEditorContextMode"
								[count]="(visibleModifiedTasks$ | async)?.length || 0"
								[attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: task.name}"
								[currentIndex]="i"
								[itemId]="getTaskReorderId(task)"
								[name]="task.name"
								(activeItemChange)="onActiveItemChange($event)"
								(cancelReorder)="onCancelReorder($event)"
								(finalizePosition)="onFinalizePosition()">
								<span class="ficon-app-drag-handle" aria-hidden="true">
									<i class="ficon-app-gripper-dots-vertical"></i>
								</span>
							</div>
						}

						@if (!isEditMode) {
							<div class="task-status">
								<div
									class="status-circle"
									[class.completed]="task.completed"
									[class.active]="selectedTaskType === task.type">
									@if (task.completed) {
										<span class="ficon-app-checkmark" aria-hidden="true"></span>
									}
								</div>
							</div>
						}

						<div class="task-name">{{ task.name }}</div>
					</div>

					@if (isEditMode && task.type !== 'present') {
						<button
							class="btn-none remove-button"
							type="button"
							(click)="onTaskRemove(task); $event.stopPropagation()"
							[attr.aria-label]="'activity-task-list_remove-task-aria-label' | translate: {name: task.name}">
							<span class="ficon-app-x" aria-hidden="true"></span>
						</button>
					}
				</div>
			}
		</div>
	</div>

	@if (isEditMode && (recommendedTasks$ | async)?.length > 0) {
		<div class="recommended-tasks-container">
			<div class="task-pane-header">
				<h4 class="task-pane-title">{{ 'activity-task-list_recommended-tasks' | translate }}</h4>
				<button
					type="button"
					class="btn-none task-pane-help-button"
					[matTooltip]="'activity-task-list_recommended-tasks-tooltip' | translate: translationParams"
					[attr.aria-label]="'activity-task-list_recommended-tasks-help_aria-label' | translate">
					<span class="ficon-app-help-circle-outline" aria-hidden="true"></span>
				</button>
			</div>
			<div
				cdkDropList
				id="recommended-list"
				class="recommended-task-list"
				role="list"
				(cdkDropListDropped)="onRecommendedDrop($event)"
				[cdkDropListSortingDisabled]="true">
				@for (task of recommendedTasks$ | async; track task.type; let i = $index) {
					<div class="task-item-wrapper" role="listitem">
						<div
							#recommendedListItem
							cdkDrag
							tabindex="0"
							class="task-item"
							role="link"
							[attr.aria-current]="selectedTaskType === task.type ? 'page' : null"
							[attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: task.name}"
							accessibleDropList
							[accessibleDropListUseLiveRegionFallback]="isEditorContextMode"
							[count]="(recommendedTasks$ | async)?.length"
							[currentIndex]="i"
							[cdkDragData]="task"
							cdkDragPreviewClass="activity-task-pane__drag-preview"
							[itemId]="getTaskReorderId(task)"
							[name]="task.name">

							<div class="task-name">{{ task.name }}</div>
						</div>

						<button
							class="btn tertiary-btn add-button"
							type="button"
							(click)="onAddRecommendedTask(task)"
							[attr.aria-label]="'activity-task-list_add-task' | translate: {name: task.name}">
							<span class="ficon-add" aria-hidden="true"></span>
							{{ 'common_add' | translate }}
						</button>
					</div>
				}
			</div>
		</div>
	}
</div>
